module.exports = __webpack_public_path__ + "media/images/edion/en/header-b17e2b11001b87ccee21916135ea0adb.png";